import { useState, useCallback } from "react";
import { db } from "services/firebaseConfig";
import {
  collection,
  query,
  getDocs,
  doc,
  setDoc,
  deleteDoc,
  Timestamp,
  orderBy,
} from "firebase/firestore";
import toast from "react-hot-toast";

export const useGuias = () => {
  const [guias, setGuias] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Busca todos os guias
  const fetchGuias = useCallback(async () => {
    setIsLoading(true);
    try {
      const q = query(collection(db, "guias"), orderBy("name"));
      const querySnapshot = await getDocs(q);
      const fetchedGuias = [];
      querySnapshot.forEach((doc) => {
        fetchedGuias.push({ id: doc.id, ...doc.data() });
      });
      setGuias(fetchedGuias);
    } catch (error) {
      console.error("Erro ao buscar guias:", error);
      toast.error("Erro ao carregar guias de turismo.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Adiciona ou Atualiza um guia
  const addGuia = async (data) => {
    try {
      // Limpa o telefone para usar como ID
      const cleanPhone = data.phone.replace(/\D/g, "");

      if (!cleanPhone) {
        throw new Error("Telefone inválido para cadastro.");
      }

      const docId = cleanPhone; // ID do documento será o telefone
      const docRef = doc(db, "guias", docId);

      const guiaData = {
        name: data.name,
        phone: data.phone,
        createdAt: data.createdAt || Timestamp.now(),
        lastUpdate: Timestamp.now(),
        source: data.source || "manual",
      };

      await setDoc(docRef, guiaData, { merge: true });
      return true;
    } catch (error) {
      console.error("Erro ao salvar guia:", error);
      toast.error(`Erro ao salvar guia: ${error.message}`);
      return false;
    }
  };

  const deleteGuia = async (guiaId) => {
    if (window.confirm("Tem certeza que deseja excluir este guia?")) {
      try {
        await deleteDoc(doc(db, "guias", guiaId));
        toast.success("Guia excluído.");
        fetchGuias();
      } catch (error) {
        toast.error("Erro ao excluir guia.");
      }
    }
  };

  return {
    guias,
    isLoading,
    fetchGuias,
    addGuia,
    deleteGuia,
  };
};
